export const elementStageNames = {
  长生: { color: "#7CD36D" },
  沐浴: { color: "#52C46A" },
  冠带: { color: "#2FB267" },
  临官: { color: "#13A157" },
  帝旺: { color: "#F25C2E" },
  衰: { color: "#D88C46" },
  病: { color: "#C0A050" },
  死: { color: "#A88F72" },
  墓: { color: "#8E7E60" },
  绝: { color: "#736B6B" },
  胎: { color: "#5B87C4" },
  养: { color: "#4EA0E8" },
};

export const tenGods = {
  比肩: { color: "#808080" },
  劫財: { color: "#606060" },
  食神: { color: "#3FA370" },
  傷官: { color: "#1F7F5C" },
  偏財: { color: "#E6B200" },
  正財: { color: "#C89200" },
  偏印: { color: "#3F7FD8" },
  正印: { color: "#005AC8" },
  七殺: { color: "#D94A38" },
  正官: { color: "#A51E2C" },
};

export const elementLabels: Record<string, string> = {
  木: "Дерево",
  火: "Огонь",
  土: "Земля",
  金: "Металл",
  水: "Вода",
};

export const elementColors: Record<string, string> = {
  木: "#39af53",
  火: "#f55",
  土: "#da8f3a",
  金: "#c7c7c7",
  水: "#3495eb",
};

export const ownerOrder = ["hour", "day", "month", "year"];
